import { Select } from 'radix-ui'
import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui/text'

export function SelectItem({
  children,
  className,
  value,
  ...props
}: Omit<React.ComponentProps<typeof Select.Item>, 'value'> & { value: string | number }) {
  return (
    <Select.Item
      value={String(value)}
      className={cn(
        'relative flex cursor-pointer items-center px-3 py-1.5 transition-colors outline-none select-none',
        'data-[state=checked]:bg-primary-selected',
        'data-highlighted:bg-action-focused',
        'data-highlighted:hover:bg-action-hovered',
        'active:bg-action-focused',
        'data-disabled:text-text-disabled data-disabled:pointer-events-none',
        className,
      )}
      {...props}
    >
      <Select.ItemText asChild>
        <Text appearance="BODY2">{children}</Text>
      </Select.ItemText>
    </Select.Item>
  )
}
